import React from "react";
import { TaskItem } from "./models";
import {
  Confounders,
  ConfoundersDefinition,
  Demographics,
  DemographicsDefinition,
  VHI10,
  VHI10Definition,
  VoicePerception,
  VoicePerceptionDefinition,
  PHQ9,
  PHQ9Definition,
  GAD7,
  GAD7Definition,
} from "./questionnaires/generic/index";

import {
  DyspneaIndex,
  DyspneaIndexDefinition,
  LeicesterCough,
  LeicesterCoughDefinition
} from "./questionnaires/respiratory";
import {
  PANAS,
  CustomAffectScale,
  DSM5Adult,
  ADHDAdult,
  PANASDefinition,
  CustomAffectScaleDefinition,
  DSM5AdultDefinition,
  ADHDAdultDefinition
} from "./questionnaires/mood";
import {
  AudioCheck,
  AudioCheckDefinition,
  Diadochokinesis,
  DiadochokinesisDefinition,
  FreeSpeechGeneric,
  FreeSpeechDefinition,
  Glides,
  HarvardSentences,
  HarvardSentencesDefinition,
  GlidesDefinition,
  Loudness,
  LoudnessDefinition,
  MaximumPhonationTime,
  MaximumPhonationTimeDefinition,
  PictureDescription,
  PictureDescriptionDefinition,
  ProlongedVowel,
  ProlongedVowelDefinition,
  RespirationAndCough,
  RespirationAndCoughDefinition,
  StoryRecall,
  StoryRecallDefinition
} from "./acoustic-tasks/generic/index";
import {
  CapeVSentences,
  CapeVSentencesDefinition,
  CaterpillarPassage,
  CaterpillarPassageDefinition,
} from "./acoustic-tasks/voice";
import {
  ProductiveVocabulary,
  ProductiveVocabularyDefinition,
  RandomItemGeneration,
  RandomItemGenerationDefinition,
  WordColorStroop,
  WordColorStroopDefinition
} from "./acoustic-tasks/neuro";

const TaskView = ({task, onCompletion} : {task: TaskItem, onCompletion: (task: TaskItem) => void}) => {

  const handleOnCompletion = () => {
    onCompletion(task);
  };

  function renderTask() {
    switch(task.name) {
      // Questionnaires
      case DemographicsDefinition.name: return (<Demographics onCompletion={handleOnCompletion}/>);
      case ConfoundersDefinition.name: return (<Confounders onCompletion={handleOnCompletion}/>);
      case VHI10Definition.name: return (<VHI10 onCompletion={handleOnCompletion}/>);
      case PHQ9Definition.name: return (<PHQ9 onCompletion={handleOnCompletion}/>);
      case GAD7Definition.name: return (<GAD7 onCompletion={handleOnCompletion}/>);
      case PANASDefinition.name: return (<PANAS onCompletion={handleOnCompletion}/>);
      case CustomAffectScaleDefinition.name: return (<CustomAffectScale onCompletion={handleOnCompletion}/>);
      case DSM5AdultDefinition.name: return (<DSM5Adult onCompletion={handleOnCompletion}/>);
      case ADHDAdultDefinition.name: return (<ADHDAdult onCompletion={handleOnCompletion}/>);
      case DyspneaIndexDefinition.name: return (<DyspneaIndex onCompletion={handleOnCompletion}/>);
      case LeicesterCoughDefinition.name: return (<LeicesterCough onCompletion={handleOnCompletion}/>);
      case VoicePerceptionDefinition.name: return (<VoicePerception onCompletion={handleOnCompletion}/>);
      // Acoustic Tasks
      case AudioCheckDefinition.name: return (<AudioCheck onCompletion={handleOnCompletion}/>);
      case DiadochokinesisDefinition.name: return (<Diadochokinesis onCompletion={handleOnCompletion}/>);
      case FreeSpeechDefinition.name: return (<FreeSpeechGeneric onCompletion={handleOnCompletion}/>);
      case GlidesDefinition.name: return (<Glides onCompletion={handleOnCompletion}/>);
      case HarvardSentencesDefinition.name: return (<HarvardSentences onCompletion={handleOnCompletion}/>);
      case LoudnessDefinition.name: return (<Loudness onCompletion={handleOnCompletion}/>);
      case MaximumPhonationTimeDefinition.name: return (<MaximumPhonationTime onCompletion={handleOnCompletion}/>);
      case PictureDescriptionDefinition.name: return (<PictureDescription onCompletion={handleOnCompletion}/>);
      case ProlongedVowelDefinition.name: return (<ProlongedVowel onCompletion={handleOnCompletion}/>);
      case RespirationAndCoughDefinition.name: return (<RespirationAndCough onCompletion={handleOnCompletion}/>);
      case StoryRecallDefinition.name: return (<StoryRecall onCompletion={handleOnCompletion}/>);
      // Voice Tasks
      case CapeVSentencesDefinition.name: return (<CapeVSentences onCompletion={handleOnCompletion}/>);
      case CaterpillarPassageDefinition.name: return (<CaterpillarPassage onCompletion={handleOnCompletion}/>);
      // Neuro Tasks
      case ProductiveVocabularyDefinition.name: return (<ProductiveVocabulary onCompletion={handleOnCompletion}/>);
      case RandomItemGenerationDefinition.name: return (<RandomItemGeneration onCompletion={handleOnCompletion}/>);
      case WordColorStroopDefinition.name: return (<WordColorStroop onCompletion={handleOnCompletion}/>);
      default: return (<></>);
    }
  }

  return (
    <div>
      {renderTask()}
    </div>
  );
};

export default TaskView;
